import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Config from './config'
import axios from 'axios'
import vuetify from './plugins/vuetify';
import YfxCloudAuth from '@yodatech/vue-yfx-cloud-auth'


Vue.config.productionTip = false
Vue.prototype.$config = Config
Vue.prototype.$http = axios

Vue.use(YfxCloudAuth, {axios: axios, store: store, serviceName: "cloud-scopes", ...Config.authConfig})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
